import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/commissions`;
const token = localStorage.getItem("token");

/// GET
// Récupérer toutes les commissions
export const getAllCommissions = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allcommissions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des commissions:", error);
  }
};

// Récupérer une commission par ID
export const getCommissionById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de la commission:", error);
  }
};

// Compter les commissions
export const countCommissions = async () => {
  try {
    const response = await axios.get(`${apiUrl}/count`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des commissions:", error);
  }
};

/// POST
// Créer une commission
export const createCommission = async (commissionData) => {
  try {
    await axios.post(`${apiUrl}/create`, commissionData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la création de la commission:", error);
  }
};

/// PUT
// Mettre à jour une commission
export const updateCommission = async (id, commissionData) => {
  try {
    await axios.put(`${apiUrl}/update/${id}`, commissionData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la commission:", error);
  }
};

/// DELETE
// Supprimer une commission
export const deleteCommission = async (id) => {
  try {
    await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression de la commission:", error);
  }
};
